import Vue from 'vue'
import myApp from './myApp.vue'
import router from './router'
import store from './store'

import './assets/FontAwesome_Pro/css/all.css'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'
import Notify from 'mdbvue/lib/components/Notify'

import * as mdbvue from 'mdbvue'

Vue.use(VueAwesomeSwiper)
Vue.use(Notify)
for (const component in mdbvue) {
  Vue.component(component, mdbvue[component])
}


/*import $ from 'jquery'
window.jQuery = $
jQuery = $
window.$ = window.jQuery*/

import 'bootstrap'

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})

router.afterEach((to,from,next) => {

  window.scrollTo(0,0);

})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})





// 百度：

var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?b3bb58d66da33d73b607300262397c58";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();

router.beforeEach((to, from, next) => {
  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
  }
  next();
});
// 百度





// 增加自定义js、方法:


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(myApp)
}).$mount('#app')
